<div class="home-card app-widget-event">
    <div class="title carousel-control">
        <h3>{{ 'home.widgetEvent.title' | translate }}</h3>

        <div class="carousel-control-btn d-none d-md-flex">
            <button
                type="button"
                data-target="#carouselEvents"
                data-slide="prev"
                [disabled]="events.length <= 1"
                [appTrack]="'homepage_event_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'previous'
                }"
            >
                <i class="pi pi-angle-left"></i>
                <span class="sr-only">Previous</span>
            </button>
            <button
                type="button"
                data-target="#carouselEvents"
                data-slide="next"
                [disabled]="events.length <= 1"
                [appTrack]="'homepage_event_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'next'
                }"
            >
                <i class="pi pi-angle-right"></i>
                <span class="sr-only">Next</span>
            </button>
        </div>
    </div>

    <div #carouselEvents id="carouselEvents" class="carousel slide" data-ride="carousel" data-interval="false">
        <div class="carousel-inner">
            <ng-container *ngIf="events.length > 0 && !isLoading">
                <div class="carousel-item" *ngFor="let event of events; let isFirst = first" [class.active]="isFirst">
                    <div class="d-flex flex-md-row flex-column">
                        <div class="carousel-left-items d-none d-md-flex">
                            <div class="d-flex flex-column align-items-center w-fit">
                                <i class="pi pi-clock"></i>
                                <p class="bold-info">J{{ defineCountDown(event.startDate) }}</p>
                            </div>

                            <button
                                (click)="openJoinEventDialog(event)"
                                class="btn btn-secondary"
                                type="button"
                                [appTrack]="'homepage_event_register_clicked'"
                                [appTrackParams]="{
                                    event_id: event.id
                                }"
                            >
                                {{ 'home.widgetEvent.join' | translate }}
                            </button>
                        </div>

                        <a tabindex="0" (click)="goToEventPage(event.id)" class="carousel-main">
                            <h4>{{ event.name }}</h4>
                            <p class="font-detail">{{ getTypeLabel(event.type) }}</p>

                            <div class="carousel-dates">
                                <p>
                                    <span class="font-detail">{{ 'home.widgetEvent.startDate' | translate }}</span
                                    ><br />{{ event.startDate | dateFormatted : 'dd/MM/yyyy HH:mm' }}
                                </p>

                                <i class="pi pi-caret-right"></i>

                                <p>
                                    <span class="font-detail">{{ 'home.widgetEvent.endDate' | translate }}</span
                                    ><br />{{ event.endDate | dateFormatted : 'dd/MM/yyyy HH:mm' }}
                                </p>
                            </div>

                            <div class="widget-pill-container">
                                <span>
                                    <i class="pi pi-at"></i>
                                    {{ getAccessType(event.accessType) | translate }}
                                </span>
                            </div>
                        </a>
                    </div>

                    <dialog-join-event
                        *ngIf="!isEventWithExternalLink(event); else externalLinkDialog"
                        class="position-absolute"
                        [isModalDisplayed]="joinEventDialog"
                        [event]="event"
                        [displaySeeMoreButton]="true"
                        (acted)="userJoinedEvent()"
                        (visibleChange)="closeJoinEventDialog()"
                    >
                    </dialog-join-event>

                    <!-- if external link -->
                    <ng-template #externalLinkDialog>
                        <p-dialog
                            header="{{ 'events.modals.joinExternal.title' | translate }}"
                            [modal]="true"
                            [dismissableMask]="true"
                            [(visible)]="joinEventDialog"
                            [draggable]="false"
                            [resizable]="false"
                            (onHide)="closeJoinEventDialog()"
                        >
                            <p>{{ 'events.modals.joinExternal.message' | translate : { eventTitle: event.name } }}</p>
                            <div class="d-flex justify-content-end gap-2">
                                <button class="btn btn-secondary" (click)="closeJoinEventDialog()">
                                    {{ 'events.modals.joinExternal.cancel' | translate }}
                                </button>
                                <button class="btn btn-primary" (click)="goToEventExternalLink(event)">
                                    {{ 'events.modals.joinExternal.confirm' | translate }}
                                </button>
                            </div>
                        </p-dialog>
                    </ng-template>
                </div>
            </ng-container>

            <!-- SKELETON START -->
            <div class="carousel-item active" *ngIf="isLoading">
                <div class="d-flex flex-md-row flex-column">
                    <div class="carousel-left-items d-none d-md-flex">
                        <div class="d-flex flex-column align-items-center w-fit">
                            <i class="pi pi-clock"></i>
                            <p class="bold-info"><p-skeleton height="2rem" width="4rem"></p-skeleton></p>
                        </div>

                        <button class="btn btn-secondary" type="button" disabled>{{ 'home.widgetEvent.join' | translate }}</button>
                    </div>

                    <a class="carousel-main w-0 w-md-100" style="pointer-events: none; cursor: default">
                        <h4><p-skeleton width="100%" height="3rem"></p-skeleton></h4>
                        <p><p-skeleton width="10rem"></p-skeleton></p>

                        <div class="carousel-dates">
                            <p>
                                <span>{{ 'home.widgetEvent.startDate' | translate }}</span
                                ><br /><p-skeleton width="10rem"></p-skeleton>
                            </p>

                            <i class="pi pi-caret-right"></i>

                            <p>
                                <span>{{ 'home.widgetEvent.endDate' | translate }}</span
                                ><br /><p-skeleton width="10rem"></p-skeleton>
                            </p>
                        </div>

                        <div class="widget-pill-container">
                            <p-skeleton height="2rem" borderRadius="50px" width="8rem"></p-skeleton>
                        </div>
                    </a>

                    <div class="mobile-bottom-actions d-md-none">
                        <button class="btn btn-secondary" type="button">
                            {{ 'home.widgetEvent.join' | translate }}
                        </button>

                        <div class="mobile-controler">
                            <button
                                class="btn btn-secondary"
                                type="button"
                                data-target="#carouselEvents"
                                data-slide="prev"
                                [disabled]="events.length <= 1"
                            >
                                <i class="pi pi-angle-left"></i>
                            </button>
                            <button
                                class="btn btn-secondary"
                                type="button"
                                data-target="#carouselEvents"
                                data-slide="next"
                                [disabled]="events.length <= 1"
                            >
                                <i class="pi pi-angle-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- SKELETON END -->
            <p class="empty-state" *ngIf="events.length <= 0 && !isLoading">{{ 'home.widgetEvent.emptyState' | translate }}</p>
        </div>
    </div>
    <div class="mobile-bottom-actions d-md-none">
        <div class="mobile-controler">
            <button
                class="btn btn-secondary"
                type="button"
                [appTrack]="'homepage_event_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'previous'
                }"
                data-target="#carouselEvents"
                data-slide="prev"
                [disabled]="events.length <= 1"
            >
                <i class="pi pi-angle-left"></i>
                <span class="sr-only">Previous</span>
            </button>
            <button
                class="btn btn-secondary"
                type="button"
                [appTrack]="'homepage_event_carousel_browsed'"
                [appTrackParams]="{
                    direction: 'next'
                }"
                data-target="#carouselEvents"
                data-slide="next"
                [disabled]="events.length <= 1"
            >
                <i class="pi pi-angle-right"></i>
                <span class="sr-only">Next</span>
            </button>
        </div>

        <button
            (click)="openJoinEventDialog()"
            class="btn btn-secondary"
            type="button"
            [appTrack]="'homepage_event_register_clicked'"
            [appTrackParams]="{
                event_id: 'event.id'
            }"
        >
            {{ 'home.widgetEvent.join' | translate }}
        </button>
    </div>
</div>
